<template lang="pug">
    section
        v-sheet(color="grey lighten-4")
            client-portfolio
</template>

<script>
    import ClientPortfolio from "@/components/ClientPortfolio";
    import DealsWidget from "@/components/DealsWidget";
    import ClientProfitability from "@/components/ClientProfitability";

    export default {
        name: "portfolio",
        components: {
            'client-portfolio': ClientPortfolio,
            'deals-tape-widget': DealsWidget,
            'client-profitability': ClientProfitability,
        },
        data () {
            return {
                page_name: 'Текущий портфель',
                tab: null,
            }
        },
        created () {
            this.$store.commit('setCurrentViewName', this.page_name)
        }
    }
</script>

<style scoped>

</style>
